import { HttpClient } from '@angular/common/http';
import { inject, Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiPetitionsService {

  private isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  private get apiUrl(): string {
    return environment.apiUrl;
  }

  private http = inject(HttpClient);

  // Petición para obtener profesionales
  getProfessionals(params: any): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}api/coaches`, { params });
  }

  // Petición para obtener Professional Fields, Keywords y Locations
  getFilterOptions(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}api/coaches/filter-options`);
  }
  // Enviar Datos de la reserva a la API
  fetchCalendlyDetails(payload: { eventUri: string; inviteeUri?: string; coachId?: string }) {
    return this.http.post(`${this.apiUrl}auth/calendly/fetch-details`, payload);
  }

  // Enviar formulario de contacto
  sendContactForm(formData: any): Observable<any> {
    return this.http.post(`${this.apiUrl}api/contact-form`, formData);
  }

  // Enviar lead de Boston Demo Week
  sendBostonLead(data: { name: string; email: string; role: string; recaptchaToken?: string }): Observable<any> {
    return this.http.post(`${this.apiUrl}api/boston-lead`, data);
  }

  // Petición para obtener specialties por campo profesional
  getSpecialtiesByField(field: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}api/coaches/specialties`, { params: { field } });
  }

  // Petición para obtener specialties por varios campos profesionales
  getSpecialtiesByFields(fields: string[]): Observable<any> {
    const fieldParam = fields.join(',');
    return this.http.get<any>(`${this.apiUrl}api/coaches/specialties`, { params: { field: fieldParam } });
  }

  // Búsqueda de profesionales por nombre usando Atlas Search (fuzzy, autocomplete)
  // Requiere mínimo 2 caracteres — la validación también se hace en el backend
  searchProfessionalsByName(name: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}api/coaches/search`, { params: { name } });
  }
}
